<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'

defineProps<{
  name: string
  icon: IconDefinition
}>()

const open = defineModel({
  default: false,
})
</script>

<template>
  <NavButton
    :open="open"
    :aria-label="open ? `Lukk ${name.toLowerCase()}` : `Åpne ${name.toLowerCase()}`"
    :label="open ? 'Lukk' : name"
    :icon="open ? faXmark : icon"
    :on-click="() => open = !open"
    class="capitalize text-small justify-center gap-2xs flex"
    :aria-expanded="open"
    aria-haspopup="true"
  />
</template>
